import { request } from './api';

export const getMapMatrix = ({ originId, destinationId, type }) =>
  request(`maps?origin_id=${originId}&destination_id=${destinationId}&type=${type}`)
    .then(({ json }) => json)
    .catch(error => error);

export const getDirections = () => ({ error: 'Not yet implemented' });



// WEBPACK FOOTER //
// ./client/app/services/mapper.js